import { SALESCHANNEL_SUBMODULES } from 'interfaces/submodules'

// PATHS de referencia para a api
// É necessário deixar o mesmo padrão de nomes em modulos diferentes como por exemplo: CP/CDC - PROPOSAL_ID
// com isso, em paginas utilizadas em módulos diferentes(CP/CDC), é possível usar o hook da api SUBMODULES_PATH
// Através desse hook, a página sempre chama a api que ela quer(PROPOSAL_ID) e ele define com base no módulo qual path
// deve ser utilizado

export const PATHS: { [key: string]: any } = {
  LOGIN: '/login',
  RECOVERY_PASSWORD_TOKEN: '/login/esqueci-minha-senha/enviar',
  RECOVERY_PASSWORD_TOKEN_UPDATE: '/login/esqueci-minha-senha/atualizar',
  ME: '/me/',
  ME_CONFIRM_TOKEN: '/me/confirmar-contato/',
  ME_CHANGE_PASSWORD: '/me/alterar-senha/',
  ME_FUNCTIONS: '/me/funcoes/',
  USER_FUNCTION: '/me/funcoes/:userFunction/',
  ME_CONFIRM_CONTACT: '/me/confirmar-contato',
  ME_SEND_CONFIRM_CONTACT: '/me/enviar-confirmar-contato',
  ME_USER_TERMS: '/me/assinar-termo-de-uso',
  // etrabalhador
  WORKER_CREDIT_TERM: '/etrabalhador/termo/',
  WORKER_CREDIT_SIGN_TERM: '/etrabalhador/termo/assinar/',
  WORKER_CREDIT_REGISTER_CLIENT_LINK: '/etrabalhador/clientes/:companyId/novo-vinculo/',
  WORKER_CREDIT_PROPOSAL: '/etrabalhador/propostas/',
  WORKER_CREDIT_SIMULATE_CREDIT: '/etrabalhador/credito/simular/',
  WORKER_CREDIT_REQUEST_CREDIT: '/etrabalhador/credito/solicitar/',
  WORKER_CREDIT_WORKER_ID: '/etrabalhador/clientes/:id/',
  WORKER_CREDIT_PROPOSALS: '/etrabalhador/propostas/',
  WORKER_CREDIT_PROPOSAL_ID: '/etrabalhador/propostas/:id/',
  WORKER_CREDIT_CONTRACT: '/etrabalhador/contratos/',
  WORKER_CREDIT_CONTRACT_CSV: '/etrabalhador/contratos/csv',
  WORKER_CREDIT_CONTRACT_ID: '/etrabalhador/contratos/:id',
  WORKER_CREDIT_RECEIVABLE: '/etrabalhador/recebiveis/',
  WORKER_CREDIT_GENERATE_BILLET_ANTECIPATION: '/etrabalhador/contratos/:id/antecipar/',
  WORKER_CREDIT_USER_REGISTER: '/etrabalhador/usuarios/',
  WORKER_CREDIT_REGISTRATION_STATUS: '/etrabalhador/situacao-cadastro/',
  WORKER_CREDIT_CONFIRM_REGISTRATION: '/etrabalhador/confirmar-cadastro/',
  WORKER_CREDIT_OFFERS: '/etrabalhador/ofertas/',
  WORKER_CREDIT_SIMULATE_OFFER: '/etrabalhador/ofertas/credito/simular/',
  WORKER_CREDIT_REQUEST_OFFER: '/etrabalhador/ofertas/credito/solicitar/',
  WORKER_CREDIT_RENEGOTIATE_SIMULATE_LEGACY_CONTRACTS:
    '/etrabalhador/credito/renegociar/legados/simular/',
  WORKER_CREDIT_RENEGOTIATE_LEGACY_CONTRACTS: '/etrabalhador/credito/renegociar/legados/solicitar/',

  SEND_CONFIRM_CONTACT: '/login/enviar-confirmar-contato/',
  FIRST_ACCESS: '/primeiro-acesso',
  CONFIRM_TOKEN: '/login/confirmar-contato/',
  SEND_TOKEN: '/login/enviar-token/',
  REFRESH_TOKEN: '/login/atualizar-token/',
  EMPLOYEE: '/consignado/funcionarios/',
  EMPLOYEE_ID: '/consignado/funcionarios/:id/',
  WORKER: '/etrabalhador/clientes/',
  WORKER_ID: '/etrabalhador/clientes/:id/',
  IMPORT_WORKER_CSV: '/etrabalhador/clientes/csv/',
  INCOME_TAX_PDF: '/consignado/funcionarios/:id/info-ir-pdf/',
  BLOCK_EMPLOYEE_BY_ID: '/consignado/funcionarios/:id/bloqueio',
  DEMISSION_ID: '/consignado/funcionarios/:id/demitir',
  EMPLOYEE_DEMISSION: '/consignado/funcionarios/:id/demitir/',
  EMPLOYEE_BULK: '/consignado/funcionarios/bulk/',
  IMPORT_EMPLOYEE_CSV: '/consignado/funcionarios/csv/',
  SEND_EMAIL_DEMISSION_EMPLOYEE_CSV: '/consignado/funcionarios/demitir/gera-demissao',
  DELETE_LOTE_EMPLOYEE_CSV: '/consignado/funcionarios/demitir/csv',
  EMPLOYEE_CSV: '/consignado/funcionarios/relatorio/csv/',
  EMPLOYEE_CONFIRM: '/consignado/funcionarios/validar/',
  CONTRACT: '/consignado/contratos/',
  CONTRACT_CSV: '/consignado/contratos/csv/',
  PROPOSAL_CSV: '/consignado/propostas/csv/',
  CONTRACT_ID: '/consignado/contratos/:id',
  CONTRACT_HISTORIC: '/credito/historicos_contratos/:id',
  CONTRACT_PAYMENTS: '/credito/historicos_pagamentos/:id',
  CEP_COMPANIES: '/consignado/empresas',
  CEP_COMPANIES_EMPLOYEE_INFOS: '/consignado/empresas/empregos',
  CEP_COMPANIES_CONTRACTS_INFOS: '/consignado/empresas/contratos',
  CEP_COMPANIES_REPASS_INFOS: '/consignado/empresas/lotes',
  RECEIVABLE: '/consignado/recebiveis/',
  RECEIVABLES_ID: '/consignado/recebiveis/:id/',
  AVERBATION_APPROVED: '/consignado/contratos/averbar/',
  AVERBATION_DENIED: '/consignado/contratos/negar-averbacao/',
  COVENANT: '/consignado/convenios/',
  COVENANT_ID: '/consignado/convenios/:id/',
  LOT: '/consignado/lotes/',
  LOT_CSV: '/consignado/lotes/csv/',
  LOT_ID_GET: '/consignado/lotes/:id/detalhes',
  LOT_ID_BULK_PATCH: '/consignado/lotes/:id/detalhes/bulk/',
  LOT_ID: '/consignado/lotes/:id/',
  LOT_SUBMIT: '/consignado/lotes/:id/submeter/',
  USER: '/usuarios/',
  USER_ID: '/usuarios/:id/',
  USER_PERMISSION_DELETE: '/usuarios/:usuarioCpf/',
  ACCESS_PROFILE: '/perfis/',
  ACCESS_PROFILE_ID: '/perfis/:id',

  PROPOSALS: '/consignado/propostas/',
  PROPOSAL_ID: '/consignado/propostas/:id/',
  PORTABILITIES: '/consignado/portabilidades/',
  PORTABILITY_ID: '/consignado/portabilidades/:id',
  APPROVE_PORTABILITY: '/consignado/portabilidades/:id/averbar/',
  APPROVE_DOCUMENT: '/consignado/funcionarios/documento-comprovacao/:id/aprovar/',
  SIGN_PORTABILITY: '/consignado/portabilidades/:id/assinar',
  SIGN_CONTRACT: '/consignado/contratos/:id/assinar',
  SEND_INVITE: '/usuarios/:id/enviar-convite',
  GENERATE_BILLET: '/cobranca/boletos/',
  GENERATE_BILLET_ANTECIPATION: '/cobranca/boletos/antecipar',
  SEND_BILLET: '/cobranca/boletos/:id/enviar/',
  GENERATE_BILLET_SALESOFF: '/cobranca/boletos/liquidar/',
  SEND_BILLET_SALESOFF: '/cobranca/boletos/liquidar/:id/enviar/',
  TRANSFER_EMPLOYEE_SUPERVISOR: '/consignado/funcionarios/:cpf/:cnpj/transferir/',
  TRANSFER_EMPLOYEE: '/consignado/funcionarios/:cpf/transferir/',
  LGPD_SEND_TOKEN: '/consignado/cadastro-lgpd/enviar-token/',
  LGPD_VALIDATE: '/consignado/cadastro-lgpd/validar-token/',
  LGPD_GET_EMPLOYEES: '/consignado/cadastro-lgpd/',
  LGPD_GET_EMPLOYEE: '/consignado/cadastro-lgpd/:id/',
  LGPD_APPROVE_EMPLOYEES: '/consignado/cadastro-lgpd/aprovar/',
  LGPD_DENY_EMPLOYEES: '/consignado/cadastro-lgpd/rejeitar/',
  LGPD_GENERATE_PDF: '/consignado/cadastro-lgpd/emitir-pdf/:id',
  VERIFY_LOGIN_STATUS: '/login/situacao-cadastro',
  VERIFY_LOGIN: '/login/verificar-cadastro',
  ENTITY_PERMISSIONS: '/permissoes/info/entidade/',
  GENERATE_SIGN_CEP: '/consignado/contratos/:id/link-assinatura/',
  PORTABILITY_GENERATE_SIGN_CEP: '/consignado/portabilidades/:id/link-assinatura',
  REACTIVATE: '/consignado/funcionarios/:id/reverter-demissao',
  SEND_DOCUMENTS: '/consignado/funcionarios/documento-comprovacao/',
  RESEND_DOCUMENT: '/consignado/funcionarios/documento-comprovacao/reenviar/:id',
  PERSON: '/pessoas/:id',
  CONFIRM_REGISTER: '/login/confirmar-cadastro/',
  CONFIRM_REGISTER_FGTS: '/cp/clientes/fgts/cadastro/',
  REGISTER_CP_FGTS: '/cp/clientes/fgts/confirmar-cadastro/',

  // Endpoints do novo cartao consignado privado //
  CONSIGNED_PERMISSION: '/consignado/',
  CONSIGNED_CARD_SIMULATE: '/consignado/consigprivc/credito/simular',
  CONSIGNED_CARD_REQUEST: '/consignado/consigprivc/credito/solicitar',

  // Endpoints do novo cartao consignado publico //

  CONSIGNED_CARD_PUBLIC_SIMULATE: '/consignado/consigpubc/credito/simular',
  CONSIGNED_CARD_PUBLIC_REQUEST: '/consignado/consigpubc/credito/solicitar',

  // Endpoints de solicitar, renegociar e portabilidade consignado privado //

  SIMULATE_PORTABILITY: '/consignado/consigpriv/portabilidades/simular/',
  SIMULATE_CREDIT: '/consignado/consigpriv/credito/simular/',
  REQUEST_CREDIT: '/consignado/consigpriv/credito/solicitar/',
  RENEGOTIATE_SIMULATE: '/consignado/consigpriv/renegociar/simular/',
  RENEGOTIATE_SIMULATE_CARD: '/consignado/consigprivc/renegociar/simular/',
  RENEGOTIATE: '/consignado/consigpriv/renegociar/solicitar/',
  RENEGOTIATE_CARD: '/consignado/consigprivc/renegociar/solicitar/',
  REQUEST_PORTABILITY: '/consignado/consigpriv/portabilidades/solicitar/',

  // Endpoints de solicitar, renegociar e portabilidade consignado publico //

  SIMULATE_PORTABILITY_PUBLIC: '/consignado/consigpub/portabilidades/simular/',
  SIMULATE_CREDIT_PUBLIC: '/consignado/consigpub/credito/simular/',
  REQUEST_CREDIT_PUBLIC: '/consignado/consigpub/credito/solicitar/',
  RENEGOTIATE_SIMULATE_PUBLIC: '/consignado/consigpub/renegociar/simular/',
  RENEGOTIATE_SIMULATE_PUBLIC_CARD: '/consignado/consigpubc/renegociar/simular/',
  RENEGOTIATE_PUBLIC: '/consignado/consigpub/renegociar/solicitar/',
  RENEGOTIATE_PUBLIC_CARD: '/consignado/consigpubc/renegociar/solicitar/',
  REQUEST_PORTABILITY_PUBLIC: '/consignado/consigpub/portabilidades/solicitar/',

  // Endpoints genéricos

  BANKS: '/credito/bancos',

  [SALESCHANNEL_SUBMODULES.CP]: {
    CONTRACTS: '/cp/contratos/',
    CONTRACT_ID: '/cp/contratos/:id',
    RECEIVABLE: '/cp/recebiveis/',
    APPROVE_DOCUMENT: '/cp/clientes/documento-comprovacao/:id/aprovar/',
    RESEND_DOCUMENT: '/cp/clientes/documento-comprovacao/proposta/:id/reenviar/',
    RESEND_UNIQ_DOCUMENT: '/cp/clientes/documento-comprovacao/reenviar/:id',
    SIMULATE_FGTS: '/cp/credito/garantia-fgts/simular/',
    REQUEST_FGTS: '/cp/credito/garantia-fgts/solicitar/',
    REQUEST_FGTS_PAYMENTS: '/personalizacoes/pefisa/interfaces/:cpf/contas/',
    FGTS_CAIXA: '/cp/credito/:id/consultar-caixa',
    SIGN_CONTRACT: '/cp/contratos/:id/assinar/',
    RENEGOTIATE_SIMULATE: '/cp/contratos/renegociar/simular/',
    RENEGOTIATE: '/cp/contratos/renegociar/solicitar/',
    PROPOSAL_ID: '/cp/propostas/:id/',
    SEND_DOCUMENTS: '/cp/clientes/documento-comprovacao/',
    SALES_CHANNEL_ID: '/cp/convenios/',
    RESEND_PENDING_SIGN_MAIL: '/cp/contratos/:id/reenviar-assinatura',
    PROPOSALS: '/cp/propostas/',
    SIMULATE_CREDIT: '/cp/credito/simular/',
    SIMULATE_CREDIT_POST: '/cp/credito/simular/obter',
    REQUEST_CREDIT: '/cp/credito/solicitar/',
    CLIENT_ID: '/cp/clientes/:id/',
    CLIENT: '/cp/clientes/',
    CANCELEDBOOKING: '/cp/credito/:cpf/cancelar-contrato-proposta-fgts',
    GENERATE_CSV: '/usuarios/list-csv/',
  },
  [SALESCHANNEL_SUBMODULES.CDC]: {
    CONTRACTS: '/cdc/contratos/',
    CONTRACT_ID: '/cdc/contratos/:id',
    RECEIVABLE: '/cdc/recebiveis/',
    APPROVE_DOCUMENT: '/cdc/clientes/documento-comprovacao/:id/aprovar/',
    RESEND_DOCUMENT: '/cdc/clientes/documento-comprovacao/proposta/:id/reenviar/',
    RESEND_UNIQ_DOCUMENT: '/cdc/clientes/documento-comprovacao/reenviar/:id',
    SIMULATE_FGTS: '/cdc/credito/garantia-fgts/simular/',
    SIGN_CONTRACT: '/cdc/contratos/:id/assinar/',
    RENEGOTIATE_SIMULATE: '/cdc/contratos/renegociar/simular/',
    RENEGOTIATE: '/cdc/contratos/renegociar/solicitar/',
    PROPOSAL_ID: '/cdc/propostas/:id/',
    SEND_DOCUMENTS: '/cdc/clientes/documento-comprovacao/',
    SALES_CHANNEL_ID: '/cdc/convenios/',
    RESEND_PENDING_SIGN_MAIL: '/cdc/contratos/:id/reenviar-assinatura',
    PROPOSALS: '/cdc/propostas/',
    SIMULATE_CREDIT: '/cdc/credito/simular/',
    SIMULATE_CREDIT_POST: '/cdc/credito/simular/obter',
    REQUEST_CREDIT: '/cdc/credito/solicitar/',
    CLIENT_ID: '/cdc/clientes/:id/',
    CLIENT: '/cdc/clientes/',
    METADATA: '/propostas/atualizar_metadados/:id',
  },
  [SALESCHANNEL_SUBMODULES.CDV]: {
    CONTRACTS: '/cdc-veiculo/contratos/',
    CONTRACT_ID: '/cdc-veiculo/contratos/:id',
    RECEIVABLE: '/cdc-veiculo/recebiveis/',
    APPROVE_DOCUMENT: '/cdc-veiculo/clientes/documento-comprovacao/:id/aprovar/',
    RESEND_DOCUMENT: '/cdc-veiculo/clientes/documento-comprovacao/proposta/:id/reenviar/',
    RESEND_UNIQ_DOCUMENT: '/cdc-veiculo/clientes/documento-comprovacao/reenviar/:id',
    SIGN_CONTRACT: '/cdc-veiculo/contratos/:id/assinar/',
    RENEGOTIATE_SIMULATE: '/cdc-veiculo/contratos/renegociar/simular/',
    RENEGOTIATE: '/cdc-veiculo/contratos/renegociar/solicitar/',
    PROPOSAL_ID: '/cdc-veiculo/propostas/:id/',
    SEND_DOCUMENTS: '/cdc-veiculo/clientes/documento-comprovacao/',
    SALES_CHANNEL_ID: '/cdc-veiculo/convenios/',
    RESEND_PENDING_SIGN_MAIL: '/cdc-veiculo/contratos/:id/reenviar-assinatura',
    PROPOSALS: '/cdc-veiculo/propostas/',
    SIMULATE_CREDIT: '/cdc-veiculo/credito/simular/',
    REQUEST_CREDIT: '/cdc-veiculo/credito/solicitar/',
    CLIENT_ID: '/cdc-veiculo/clientes/:id/',
    CLIENT: '/cdc-veiculo/clientes/',
    FIPE_TABLE: '/cdc-veiculo/fipe/',
    FIPE_TABLE_MARCA: '/cdc-veiculo/fipe/marcas',
    FIPE_TABLE_MODELS: '/cdc-veiculo/fipe/modelos',
    CLIENT_PJ: '/cdc-veiculo/pj/clientes/',
    CLIENT_ID_PJ: '/cdc-veiculo/pj/clientes/:id/',
    SIMULATE_CREDIT_PJ: '/cdc-veiculo/pj/credito/simular/',
    REQUEST_CREDIT_PJ: '/cdc-veiculo/pj/credito/solicitar/',
    SIGN_CONTRACT_PJ: '/cdc-veiculo/pj/contratos/:id/assinar/',
    SIMULATE_RENEGOTIATE_CREDIT_PJ: '/cdc-veiculo/pj/renegociar/simular/',
    REQUEST_RENEGOTIATE_CREDIT_PJ: '/cdc-veiculo/pj/renegociar/solicitar/',
  },
  [SALESCHANNEL_SUBMODULES.PJ]: {
    CONTRACTS: '/pj/contratos/',
    CONTRACT_ID: '/pj/contratos/:id',
    RECEIVABLE: '/pj/recebiveis/',
    APPROVE_DOCUMENT: '/pj/clientes/documento-comprovacao/:id/aprovar/',
    // @TODO: Removido, pois, não tem envio de documentação para PJ, por agora
    // RESEND_DOCUMENT: '/pj/clientes/documento-comprovacao/proposta/:id/reenviar/',
    // RESEND_UNIQ_DOCUMENT: '/pj/clientes/documento-comprovacao/reenviar/:id',
    SIGN_CONTRACT: '/pj/contratos/:id/assinar/',
    RENEGOTIATE_SIMULATE: '/pj/contratos/renegociar/simular/',
    RENEGOTIATE: '/pj/contratos/renegociar/solicitar/',
    PROPOSAL_ID: '/pj/propostas/:id/',
    SEND_DOCUMENTS: '/pj/clientes/documento-comprovacao/',
    SALES_CHANNEL_ID: '/pj/convenios/',
    RESEND_PENDING_SIGN_MAIL: '/pj/contratos/:id/reenviar-assinatura',
    PROPOSALS: '/pj/propostas/',
    CLIENT_ID: '/pj/empresas/:id/',
    CLIENT: '/pj/empresas/',
    METADATA: '/propostas/atualizar_metadados/:id',
    SIMULATE_CREDIT_DUPLICATE: '/pj/credito/descontos-duplicatas/simular',
    REQUEST_CREDIT_DUPLICATE: '/pj/credito/descontos-duplicatas/solicitar',
    SIMULATE_CREDIT_WOKRING_CAPITAL: '/pj/credito/simular',
    REQUEST_CREDIT_WOKRING_CAPITAL: '/pj/credito/solicitar',
  },
  CORBAN: {
    CORBAN_ID: '/corbans/:id',
    CORBAN: '/corbans/',
    USERS: '/corbans/usuarios',
    OPERATORS: '/corbans/:id/operadores',
    OPERATORS_ID: '/corbans/:cnpj/operadores/:id',
    CHANNELS: '/corbans/canais',
    ASSOCIATE_SUBCORBAN: '/corbans/:id/associar/:canalId',
    UPDATE_SUBCORBAN: '/corbans/:id/associar/:canalId/alterar/',
    PORTABILITY_SIMULATE: '/corbans/consignado/portabilidade/simular',
    SEND_USER_TOKEN: '/corbans/consignado/token/enviar/',
    VALIDATE_USER_TOKEN: '/corbans/consignado/token/validar/',
    SEND_PHONE_TOKEN: '/corbans/consignado/token/enviar/',
    VALIDATE_PHONE_TOKEN: '/corbans/consignado/token/validar/',
    SEND_INVITE_EMPLOYEE: '/corbans/consignado/enviar-convite-funcionario/',
    REMOVE_OPERATORS: '/corbans/:corbanid/gestores/:usuarioid/desabilitar',
    VALIDATE_TOKEN_ASSOCIATE_CORBAN: '/corbans/:corbanid/associar/:canalid/detalhar',
    EMPLOYEE_CONFIRM: '/corbans/consignado/validar-funcionario/',

    // Endpoints do etrabalhador //
    WORKER: '/corbans/etrabalhador/clientes/:cpf/vinculos/',
    WORKER_CREATE_USER: '/corbans/etrabalhador/usuarios/',
    WORKER_CREATE_CLIENT: '/corbans/etrabalhador/clientes/',
    WORKER_SEND_TERM: '/corbans/etrabalhador/termo/',
    WORKER_SIMULATE_CREDIT: '/corbans/etrabalhador/credito/simular/',
    WORKER_REQUEST_CREDIT: '/corbans/etrabalhador/credito/solicitar/',

    // Endpoints do novo cartao consignado privado //
    CONSIGNED_CARD_SIMULATE: '/corbans/consigprivc/credito/simular',
    CONSIGNED_CARD_REQUEST: '/corbans/consigprivc/credito/solicitar',

    // Endpoints do novo cartao consignado publico //

    CONSIGNED_CARD_PUBLIC_SIMULATE: '/corbans/consigpubc/credito/simular',
    CONSIGNED_CARD_PUBLIC_REQUEST: '/corbans/consigpubc/credito/solicitar',

    // Endpoints de solicitar, renegociar e portabilidade consignado privado //

    SIMULATE_PORTABILITY: '/corbans/consigpriv/portabilidades/simular/',
    SIMULATE_CREDIT: '/corbans/consigpriv/credito/simular/',
    REQUEST_CREDIT: '/corbans/consigpriv/credito/solicitar/',
    RENEGOTIATE_SIMULATE: '/corbans/consigpriv/renegociar/simular/',
    RENEGOTIATE_SIMULATE_CARD: '/corbans/consigprivc/renegociar/simular/',
    RENEGOTIATE: '/corbans/consigpriv/renegociar/solicitar/',
    RENEGOTIATE_CARD: '/corbans/consigprivc/renegociar/solicitar/',
    REQUEST_PORTABILITY: '/corbans/consigpriv/portabilidades/solicitar/',

    // Endpoints de solicitar, renegociar e portabilidade consignado publico //

    SIMULATE_PORTABILITY_PUBLIC: '/corbans/consigpub/portabilidades/simular/',
    SIMULATE_CREDIT_PUBLIC: '/corbans/consigpub/credito/simular/',
    REQUEST_CREDIT_PUBLIC: '/corbans/consigpub/credito/solicitar/',
    RENEGOTIATE_SIMULATE_PUBLIC: '/corbans/consigpub/renegociar/simular/',
    RENEGOTIATE_SIMULATE_PUBLIC_CARD: '/corbans/consigpubc/renegociar/simular/',
    RENEGOTIATE_PUBLIC: '/corbans/consigpub/renegociar/solicitar/',
    RENEGOTIATE_PUBLIC_CARD: '/corbans/consigpubc/renegociar/solicitar/',
    REQUEST_PORTABILITY_PUBLIC: '/corbans/consigpub/portabilidades/solicitar/',
    TAXES_GROUP: '/corbans/taxas/',
  },
}

export default PATHS
